export default __webpack_public_path__ + "static/studio-7973725e482fb6ef42f9bd3556f525ea.png";